import { render } from "./ShippingServiceClaimReason.vue?vue&type=template&id=73de1af0"
import script from "./ShippingServiceClaimReason.vue?vue&type=script&lang=js"
export * from "./ShippingServiceClaimReason.vue?vue&type=script&lang=js"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__